import { useSyncExternalStore } from "react";
import { subscribeToStatus, getIsProcessing } from "./tokenQueue";

/**
 * Server snapshot always returns false since there's no queue processing during SSR.
 */
const getServerSnapshot = () => false;

/**
 * Hook to get the current queue processing status.
 * Uses React 18's useSyncExternalStore for proper subscription handling.
 *
 * @returns true if the queue is currently processing requests, false otherwise
 */
export function useQueueStatus(): boolean {
  return useSyncExternalStore(
    subscribeToStatus,
    getIsProcessing,
    getServerSnapshot,
  );
}
